// import { useState } from "react";
// import { Box, Button, TextField, Typography, Alert } from "@mui/material";
// import { getOtp } from "../../api/getOtp";

// export default function LoginForm() {
//   const [phone, setPhone] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   const handleGetOtp = async () => {
//     setError("");
//     setMessage("");
//     if (!phone) {
//       setError("Please enter your phone number");
//       return;
//     }
//     setLoading(true);
//     try {
//       const data = await getOtp(phone);
//       setMessage("OTP sent successfully!");

//     } catch (err) {
//       setError(err.message || "Failed to send OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         maxWidth: 400,
//         mx: "auto",
//         mt: 10,
//         p: 4,
//         borderRadius: 2,
//         boxShadow: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
//         Login
//       </Typography>

//       {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
//       {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

//       <TextField
//         label="Phone Number"
//         variant="outlined"
//         fullWidth
//         value={phone}
//         onChange={(e) => setPhone(e.target.value)}
//         sx={{ mb: 3 }}
//       />

//       <Button
//         variant="contained"
//         fullWidth
//         onClick={handleGetOtp}
//         disabled={loading}
//       >
//         {loading ? "Sending..." : "Get OTP"}
//       </Button>
//     </Box>
//   );
// }
import React, { useState, useRef, useEffect } from "react";
import { Modal, Box, Typography, TextField, Button, IconButton } from "@mui/material";
import axios from "axios";
import { useModal } from "../../context/ModalContext";
import { toast, ToastContainer } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from "@mui/icons-material/Close";
import { useSettings } from "../../context/Settings";
import { assetUrl } from "../../utils/baseUrls";


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: '90%', sm: 500, md: 500 },
    maxWidth: '95%',
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: { xs: 2, sm: 3, md: 4 },
};

export default function LoginModal({ open, handleClose }) {
    const [step, setStep] = useState(1);
    const [phone, setPhone] = useState("");
    // const [otp, setOtp] = useState("");
    const [serverOtp, setServerOtp] = useState(null);
    const [loading, setLoading] = useState(false);


    const { setShowSignup, setShowLogin } = useModal();
    const [timer, setTimer] = useState(60);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const { settings } = useSettings();


    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputsRef = useRef([]);
    const [loginForm, setLoginForm] = useState(true)



    const resetLoginModal = () => {
        setStep(1);
        setPhone("");
        setOtp(["", "", "", "", "", ""]);
        setServerOtp(null);
    };
    useEffect(() => {

        if (step === 2 && inputsRef.current[0]) {
            inputsRef.current[0].focus();
        }
    }, [step]);

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (/^\d$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);


            if (index < 5) {
                inputsRef.current[index + 1].focus();
            }


            if (newOtp.every((digit) => digit !== "")) {
                handleVerifyOtp(newOtp.join(""));
            }
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "") {
                if (index > 0) {
                    inputsRef.current[index - 1].focus();
                }
            } else {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
            }
        }

        if (e.key === "Enter" && index === otp.length - 1) {
            e.preventDefault();
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        const enteredOtp = otp.join("");
        if (enteredOtp.length < 6) {
            toast.error("Enter complete 6-digit OTP");
            return;
        }
        handleVerifyOtp(enteredOtp);
    };

    // const handleGetOtp = async () => {
    //     if (!phone) return toast.error("Enter phone number");
    //     setLoading(true);
    //     try {
    //         const phoneWithoutCode = phone.startsWith("91") ? phone.slice(2) : phone;
    //         const res = await axios.post("http://192.168.1.114/admincashback/public/api/v2/otp", { phone:phoneWithoutCode });
    //         if (res.data.status === 200) {
    //             toast.success(res.data.message)
    //             // alert(res.data.message);
    //             setServerOtp(res.data.otp);
    //             setStep(2);
    //         }

    //         localStorage.setItem("phone",phoneWithoutCode)
    //     } catch (error) {

    //         toast.error("Failed to send OTP")

    //     }
    //     setLoading(false);
    // };
    const handleGetOtp = async () => {
        if (!phone) return toast.error("Enter phone number");
        const phoneWithoutCode = phone.startsWith("91") ? phone.slice(2) : phone;
        // if (!/^\d{10}$/.test(phoneWithoutCode)) {
        //     return toast.error("Phone number must be exactly 10 digits");
        // }
        if (!/^[6-9]\d{9}$/.test(phoneWithoutCode)) {
            return toast.error("Enter a valid Indian mobile number");
        }
        setOtp(["", "", "", "", "", ""]);

        setLoading(true);
        try {

            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}otp`, { phone: phoneWithoutCode });
            if (res.data.status === 200) {
                toast.success(res.data.message);
                setServerOtp(res.data.otp);
                setStep(2);
                setIsOtpSent(true);
                setTimer(60);

                // Start countdown
                const interval = setInterval(() => {
                    setTimer((prev) => {
                        if (prev <= 1) {
                            clearInterval(interval);
                            setIsOtpSent(false); // allow resending OTP
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            }
            localStorage.setItem("phone", phoneWithoutCode);
        } catch (error) {

            toast.error("Failed to send OTP");
        }
        setLoading(false);
    };
    const handleVerifyOtp = async (otpValue = null) => {
        const otpToVerify = otpValue || otp.join("");

        if (!otpToVerify) return toast.error("Enter OTP");
        setLoading(true);



        if (parseInt(otpToVerify) === serverOtp) {
            try {
                const phoneWithoutCode = phone.startsWith("91") ? phone.slice(2) : phone;

                const loginRes = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}login`,
                    { phone: phoneWithoutCode }
                );

                if (loginRes.data.status === 200) {
                    const { token, user } = loginRes.data.data;
                    localStorage.setItem("authToken", token);
                    localStorage.setItem("role", JSON.stringify(user?.role));

                    toast.success("Logged in successfully!");
                    handleClose();
                    window.location.reload();
                } else {

                }
            } catch (error) {
                if (
                    error.response?.status === 404 ||
                    error.response?.data?.status == 404 ||
                    error.response?.data?.message === "User not found"
                ) {
                    resetLoginModal();
                    handleClose();
                    setShowSignup(true);
                } else {

                }
            }
        } else {
            toast.error("Incorrect OTP");

        }
        setLoading(false);
    };


    // const handleVerifyOtp = async () => {
    //     const otpValue = otp.join("");

    //     if (!otpValue) return toast.error("Enter OTP");
    //     setLoading(true);



    //     if (parseInt(otpValue) === serverOtp) {
    //         try {
    //             const phoneWithoutCode = phone.startsWith("91") ? phone.slice(2) : phone;

    //             const loginRes = await axios.post(
    //                 `${process.env.REACT_APP_BASE_URL}login`,
    //                 { phone: phoneWithoutCode }
    //             );



    //             if (loginRes.data.status === 200) {

    //                 const { token, user } = loginRes.data.data;


    //                 localStorage.setItem("authToken", token);
    //                 localStorage.setItem("role", JSON.stringify(user?.role));

    //                 toast.success("Logged in successfully!");
    //                 handleClose();
    //                 window.location.reload()

    //             } else {

    //             }

    //         } catch (error) {



    //             if (
    //                 error.response?.status === 404 ||
    //                 error.response?.data?.status == 404 ||
    //                 error.response?.data?.message === "User not found"
    //             ) {

    //                 resetLoginModal();
    //                 handleClose();
    //                 setShowSignup(true);
    //                 // open signup

    //             } else {

    //             }
    //         }
    //     } else {
    //         toast.error("Incorrect OTP")

    //     }
    //     setLoading(false);
    // };


    return (
        <Modal open={open} onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {

                return;
            }
            handleClose();

            open = { open }


        }}>
            <Box sx={style}>
                <IconButton
                    onClick={handleClose}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>
                {step === 1 ? (
                    // <>
                    //     <Box
                    //         sx={{
                    //             display: "flex",
                    //             flexDirection: { xs: "column", sm: "row" },
                    //             alignItems: "center",
                    //             justifyContent: { xs: "center", sm: "center" },
                    //             mb: 3,
                    //             gap: 2,
                    //             textAlign: { xs: "center", sm: "left" },
                    //         }}
                    //     >
                    //         <Box
                    //             component="img"
                    //             src="/assets/images/logo.png"
                    //             alt="Logo"
                    //             sx={{ height: { xs: 60, sm: 80 }, width: { xs: 60, sm: 80 } }}
                    //         />
                    //         <Typography
                    //             variant="h5"
                    //             sx={{ fontWeight: 500, fontSize: { xs: "1.25rem", sm: "1.2rem" } }}
                    //         >
                    //             Welcome to GreenHeap Farms
                    //         </Typography>
                    //     </Box>

                    //     <Typography variant="h6" sx={{ mb: 2 }} textAlign="center">
                    //         Enter Your Mobile Number
                    //     </Typography>


                    //     <PhoneInput
                    //         country={"in"}
                    //         value={phone}
                    //         onChange={setPhone}
                    //         inputStyle={{ width: "100%", height: 45 }}
                    //         containerStyle={{ marginBottom: 16 }}
                    //         placeholder="Mobile Number"
                    //     />

                    //     <Button
                    //         fullWidth
                    //         variant="contained"
                    //         onClick={handleGetOtp}
                    //         disabled={loading}
                    //         startIcon={loading && <CircularProgress size={20} color="inherit" />}
                    //     >
                    //         Get OTP
                    //     </Button>
                    // </>
                    <>
                      
<Box sx={{ textAlign: "center", mb: 3 }}>
  {/* Image + Content Row */}
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      flexWrap: "wrap", 
    }}
  >
    {/* Image */}
    <Box
      component="img"
      src={settings?.data?.logo ? assetUrl(settings.data.logo) : "/assets/images/logo.png"}
      alt="Logo"
      sx={{
        height: { xs: 60, sm: 80, md: 90 },
        width: { xs: 60, sm: 80, md: 90 },
        flexShrink: 0,    
      }}
    />

    {/* Content */}
    <Box sx={{ maxWidth: "100%" }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          fontSize: { xs: 18, sm: 20 }, 
          wordBreak: "break-word",    
          textAlign: "center",
        }}
      >
        Welcome to Geo Rental Farms
      </Typography>
    </Box>
  </Box>

  {/* Centered Responsive Underline */}
<Box
  sx={{
    width: { xs: 90, sm: 120, md: 120 },
    height: 3,
    bgcolor: "#608900",
    borderRadius: 2,
    mx: "auto",

    mt: { xs: 1, sm: 0.5 },  
  }}
/>

</Box>

{/* Mobile Text */}
<Box sx={{ textAlign: "center", mb: 2 }}>
  <Typography
    variant="h6"
    sx={{
      fontSize: { xs: 16, sm: 20 },   
      lineHeight: 1.3,
    }}
  >
    Enter Your Mobile Number
  </Typography>

  <Typography
    sx={{
      fontSize: { xs: 13, sm: 15 },  
      color: "text.secondary",
      mt: 0.5,
      px: 1,                        
    }}
  >
    We Will Send You a Confirmation Code
  </Typography>

  {/* Custom Border */}
  <Box
    sx={{
      position: "relative",
      mt: 2,
      width: "100%",
      maxWidth: 350,
      mx: "auto",
      px: 2,           
    }}
  >
    <Box
      sx={{
        height: 3,
        bgcolor: "#608900",
        borderRadius: 2,
        width: "100%",
      }}
    />

    {/* Left dot */}
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: 12,
        transform: "translate(-50%, -50%)",
        width: 14,
        height: 14,
        bgcolor: "#608900",
        borderRadius: "50%",
      }}
    />

    {/* Right dot */}
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        right:12,
        transform: "translate(50%, -50%)",
        width: 14,
        height: 14,
        bgcolor: "#608900",
        borderRadius: "50%",
      }}
    />
  </Box>
</Box>

<Box sx={{ marginTop: 3 }}>
  {/* Phone Input */}
  <PhoneInput
    country={"in"}
    value={phone}
    onChange={setPhone}
    inputStyle={{
      width: "100%",
      height: 45,
      fontSize: "1rem",
      borderColor: "#608900",
      outline: "none",
    }}
    containerStyle={{ marginBottom: 16, width: "100%" }}   
    placeholder="Mobile Number"
 inputProps={{
 onKeyDown: (e) => {
 if (e.key === "Enter") {
e.preventDefault();
handleGetOtp();
}
  },
  }}
  />
</Box>

{/* Button */}
<Button
  fullWidth
  variant="contained"
  onClick={handleGetOtp}
  disabled={loading}
  startIcon={loading && <CircularProgress size={20} color="inherit" />}
  sx={{
    backgroundColor: "#FEB821 !important",
    color: "#ffffff !important",
    "&:hover": {
      backgroundColor: "#e6b01e !important",
    },
    fontWeight: 400,
    height: 45,
    borderRadius: 2,
    marginTop: 5,
    fontSize: { xs: 16, sm: 20 },  
  }}
>
  Get OTP
</Button>



                    </>

                ) : (
                    <>
                    
<Box sx={{ textAlign: "center", px: { xs: 1.5, sm: 5 }, py: 3 }}>

  <Typography
    variant="h5"
    sx={{
      fontWeight: 600,
      mb: 1,
      fontSize: { xs: 18, sm: 22 },
    }}
  >
    Geo Rental Farms
  </Typography>

  <Typography
    variant="subtitle1"
    sx={{
      mb: 3,
      color: "text.secondary",
      fontSize: { xs: 13, sm: 16 },
      wordBreak: "break-word",       
      px: 1,
    }}
  >
    Submit the OTP code sent to{" "}
    <strong>+91 {phone.slice(2)}</strong> and verify
  </Typography>

  {/* OTP Inputs */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: { xs: 0.8, sm: 1 },
      mb: 4,
      flexWrap: "nowrap",
      width: "100%",
      overflowX: "hidden",           
    }}
  >
    {otp.map((digit, index) => (
  
                                    <TextField
                                key={index}
                                inputRef={(el) => (inputsRef.current[index] = el)}
                                value={digit}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                variant="outlined"
                                inputProps={{
                                    maxLength: 1,
                                    style: {
                                    textAlign: "center",
                                    fontSize: 22,
                                    width: 50,
                                    height: 42,         
                                    lineHeight: "42px",  
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    },
                                }}
                                sx={{
                                    "& input": {
                                    padding: "0px",      
                                    },
                                    width: { xs: 38, sm: 50 },  
                                }}
                                />

    ))}
  </Box>

  <Button
    fullWidth
    variant="contained"
    onClick={handleVerifyOtp}
    disabled={loading}
    startIcon={loading && <CircularProgress size={20} color="inherit" />}
  >
    Verify OTP
  </Button>

  <Button
    fullWidth
    variant="text"
    sx={{ py: 1.5, color: "primary.main" }}
    onClick={() => setStep(1)}
  >
    Change Phone Number
  </Button>

  <Box sx={{ textAlign: "center", mb: 2 }}>
    {isOtpSent ? (
      <Typography variant="body2" color="text.secondary">
        Resend OTP in <strong>{timer}s</strong>
      </Typography>
    ) : (
      <Button variant="text" onClick={handleGetOtp} disabled={loading}>
        Resend OTP
      </Button>
    )}
  </Box>
</Box>

                    </>
                )}
            </Box>
        </Modal>
    );
}
